import { Classes as CoreClasses } from '@mc/react-core';
import * as UiClasses from './Classes';
import './ui.scss';

const Classes = { ...CoreClasses, ...UiClasses };

export { Classes };

export { Theme } from './theme';

export {
  Spinner,
  NonIdealState,
  Container,
  VerticalLayout,
  CardBlock,
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  D3,
  D4,
  Icon,
  Menu,
  MenuItem,
  MenuDivider,
  Popover,
  Text,
  FormGroup,
  Label,
  Tab,
  HorizontalLoader,
} from '@mc/react-core';
export { Card } from './card/Card';
export { Breadcrumbs } from './breadcrumbs/Breadcrumbs';
export { LinkBreadcrumbs } from './breadcrumbs/LinkBreadcrumbs';
export { CardBreadcrumbs } from './breadcrumbs/CardBreadcrumbs';
export { ButtonToolbar } from './button-toolbar/ButtonToolbar';
export { PrimaryButton } from './buttons/PrimaryButton';
export { SecondaryButton } from './buttons/SecondaryButton';
export { ActionButton } from './buttons/ActionButton';
export { LinkButton } from './buttons/LinkButton';
export { OutlineButton } from './buttons/OutlineButton';
export { IconButton } from './buttons/IconButton';
export { Button } from './buttons/Button';
export { LightTabs, DarkTabs, SidePanelTabs } from './tabs';
export { Tag } from './tag/Tag';
export { Table } from './table/Table';
export { useFixedHeader } from './table/useFixedHeader'; // TODO jak budeme řešit tyto hooky? - asi do core zavést komponentu Table?
export { Switch } from './switch/Switch';
export { Checkbox } from './checkbox/Checkbox';
export { RadioGroup, Radio } from './radio';
export { DetailValue } from './detail-value/DetailValue';
export { NavbarMenu } from './navbar/NavbarMenu';
export { Navbar, NavbarBrand } from './navbar/Navbar';
export { Callout } from './callout/Callout';
export { Dialog } from './dialog/Dialog';
export { DialogBody } from './dialog/DialogBody';
export { DialogFooter } from './dialog/DialogFooter';
export { ProgressBar } from './progressbar/ProgressBar';
export { Fulltext } from './fulltext/Fulltext';
export { Row, Col } from './row';
export {
  showInformation,
  showConfirmation,
  InformationModal,
  ConfirmModal,
} from './modal';
// export { DropzoneField } from './form/DropzoneField';
